import * as React from "react";
import { useAppDispatch, useAppSelector } from "hooks/store-hooks";
import { profileActions, profileSelector } from "ReactReducers/Profile/profile-reducer";
import { Item, List } from "../navigation-profile/navigation-profile";

export function NavigationMobileProfile() {
    const isLoggedIn = useAppSelector(profileSelector.loggedIn);

    // Server + første klient-render: altid null → ingen hydration-mismatch
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => setMounted(true), []);

    if (!mounted) {
        return null;
    }

    return isLoggedIn ? <LoggedIn /> : <NotLoggedIn />;
    // return isLoggedIn ? <LoggedIn /> : <NotLoggedIn siteName={props.siteName} labels={props.labels} />;
}

export function LoggedIn() {
    const userProfile = useAppSelector(profileSelector.userInfo);
    const login = useAppSelector(profileSelector.login);

    if (!userProfile) {
        return null;
    }

    return (
        <List className="navigation-mobile-profile">
            <>
                {userProfile.ProfileLinks?.map((link, index) => {
                    return <Item className="navigation-menu-item" key={index} {...link} />;
                })}
                {login && <Item Text={login.LogoutUrl?.Text} Url={login.LogoutUrl?.FullUrl} />}
            </>
        </List>
    );
}

// interface INotLoggedInProps {
//     labels: ICreateProfileModalProps["labels"];
//     siteName: SiteName;
// }

export function NotLoggedIn() {
    const dispatch = useAppDispatch();
    const login = useAppSelector(profileSelector.login);
    // const [isCreateProfileOpen, setIsCreateProfileOpen] = React.useState(false);

    if (!login) {
        return null;
    }

    return (
        <>
            <List className="navigation-mobile-profile">
                {login.LoginUrl && (
                    <Item
                        className="navigation-menu-item"
                        onClick={() => dispatch(profileActions.userLogin())}
                        Text={login.LoginUrl.Text}
                    />
                )}
                {/* {props.siteName === "gu" ? (
                    <Item
                        className="navigation-menu-item"
                        Text={login.CreateProfileUrl.Text}
                        onClick={() => setIsCreateProfileOpen(true)}
                    />
                ) : ( */}
                <Item className="navigation-menu-item" {...login.CreateProfileUrl} />
                {/* )} */}
            </List>
            {/* {props.siteName === "gu" && (
                <CreateProfileModal
                    isOpen={isCreateProfileOpen}
                    onClose={() => setIsCreateProfileOpen(false)}
                    labels={props.labels}
                />
            )} */}
        </>
    );
}
